(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-brand-info--static"]) return;
  try {
    
  let logoImage = document.querySelector('.product-brand-info__image');

  window.addEventListener('scroll', function(event) {
    // checks if visible viewport...
    if (isInViewport(logoImage)) logoImage.classList.add('animated')
  }, true)

  var isInViewport = function(elem) {
    // checks the position of the item...
    var dist = elem.getBoundingClientRect()
    // checks the position at the bottom of the viewport...
    var veiwport = document.documentElement.clientHeight
    // if the bottom of the viewport is larger than 'dist.top'...
    return dist.top <= veiwport
  }

  } catch(e) { console.error(e); }
})();
})();
